import nodeClient from "./node-client";

const endpoints = {
  user: "/service/private/v0/list/user",
  product: "/service/private/v0/list/product",
  branch: "/service/private/v0/list/branch",
};

export const fetchReportData = async (data) => {
  const response = await nodeClient.post(endpoints[data.identifier], data);
  return response.data.result;
};
